<script lang="ts">
  import ReactWrapper from "conversion_flows/ReactWrapper.svelte"
  import { PricingInsightsProps } from "pricing_insights/PricingInsights"
  import { getContext } from "svelte"
  import type { Settings } from "website_script/types/settings"

  export let carId: NonNullable<Settings["car"]>["id"]

  const { iframeHost, locale, conversionBoxDealerRating, customerName, id } =
    getContext<Settings>("settings")

  const pricingInsightsProps: PricingInsightsProps = {
    carId,
    locale,
    appHost: iframeHost,

    // TODO: This is temporary
    // We need to move ratings outside of website script to customer to allow them to be requested in customers query
    dealerRating: conversionBoxDealerRating,
    customerName,
    customerPublicUuid: id,
  }
</script>

<ReactWrapper componentName="PricingInsights" {...pricingInsightsProps} />
